import { render, staticRenderFns } from "./DisplayPanelPortraitLT.vue?vue&type=template&id=e54d3fe8&"
import script from "./DisplayPanelPortraitLT.vue?vue&type=script&lang=js&"
export * from "./DisplayPanelPortraitLT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VFadeTransition,VImg})
